import "./hierarchySidenav.less";

import { IComponentController, IComponentOptions } from "angular";

import { HIERARCHY_SERVICE, HierarchyService } from "../hierarchy-service/hierarchy.service";
import { AbstractHierarchySidenav } from "../hierarchy-support/abstractHierarchySidenav";
import { IExploringElement } from "../../typings/board/Models";

export const HIERARCHY_SIDENAV_COMPONENT: string = "hierarchySidenavComponent";

class HierarchySidenavController extends AbstractHierarchySidenav implements IComponentController {

    protected expandedFolderPaths: string[];
    protected exploringData: IExploringElement[] = [];

    static $inject = [HIERARCHY_SERVICE, "$mdToast", "$mdDialog"];
    constructor(protected hierarchyService: HierarchyService,
        protected $mdToast: ng.material.IToastService, protected $mdDialog: ng.material.IDialogService) {
            super(hierarchyService, $mdToast, $mdDialog);
    }

    protected navigateFolder(selectedCapsule: IExploringElement): void {
        this.rootFolder.isSelected = false;
        this.exploringData.forEach(el => el.isSelected = false);
        selectedCapsule.isSelected = true;
        this.hierarchyService.updateSelectedFolder(selectedCapsule.originCapsule);
        this.expandCollapseFolderCascade(selectedCapsule.originCapsule.relativePath, null);
    }
}

export const hierarchySidenavComponent: IComponentOptions = {
    controller: HierarchySidenavController,
    template: require("./hierarchySidenav.html"),
    bindings: {},
};


// WEBPACK FOOTER //
// ./app/hierarchy-nav/hierachySidenav.component.ts